var _excluded = ["decimalSeparator", "precision", "prefix", "onChange"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from 'react';
import { InputBoxed } from '../InputBoxed';
var THOUSANDS_LENGTH = 3;
var DECIMALS_LENGTH = 2;
var InputCurrency = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    decimalSeparator = ',',
    precision = DECIMALS_LENGTH,
    prefix = 'R$',
    onChange
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [inputValue, setInputValue] = useState('');

  function isNumber(number) {
    var _number$match;

    return !((_number$match = number.match(/[^0-9]/gi)) !== null && _number$match !== void 0 && _number$match.length) && !Number.isNaN(parseInt(number, 10));
  }

  function getNumberWithDots(number) {
    var count = 0;
    return !number || number === '0' ? '0' : number.split('').reverse().reduce((acc, value) => {
      if (count === THOUSANDS_LENGTH) {
        count = 1;
        return "".concat(value, ".").concat(acc);
      }

      count++;
      return "".concat(value).concat(acc);
    }, '');
  }

  function getRawNumber(n) {
    return n.length === DECIMALS_LENGTH ? parseFloat("0.".concat(n)) : parseFloat("".concat(n.slice(0, n.length - 2), ".").concat(n.slice(n.length - 2)));
  }

  function getFormattedNumber(number) {
    if (!isNumber(number)) return '';
    var isOnlyDecimals = number.length - precision <= 0;
    var decimals = isOnlyDecimals ? number : number.slice(number.length - precision, number.length);
    var leftNumber = isOnlyDecimals ? '0' : number.slice(0, number.length - precision).replace(/^0+/g, '');
    var numberWithDots = getNumberWithDots(leftNumber);
    var separator = precision > 0 ? decimalSeparator : '';
    var formattedValue = "".concat(numberWithDots).concat(separator).concat(decimals);
    return "".concat(prefix, " ").concat(formattedValue);
  }

  function onChangeInput(e) {
    var number = e.currentTarget.value.replace(/\.|,| /g, '').replace(prefix, '');
    var formattedNumber = getFormattedNumber(number);
    var rawNumber = getRawNumber(number);
    setInputValue(formattedNumber);
    if (onChange) onChange(e, rawNumber);
  }

  function updateInputValue() {
    var _props$value;

    var valueStr = ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.toString()) || '';

    if (getRawNumber(valueStr) !== (inputValue && getRawNumber(inputValue.toString()))) {
      var _valueStr;

      var hasDecimals = (_valueStr = valueStr[valueStr.length - (precision + 1)]) === null || _valueStr === void 0 ? void 0 : _valueStr.match(/[.]/);

      if (hasDecimals) {
        setInputValue(getFormattedNumber(valueStr.replace('.', '')));
      } else {
        setInputValue(getFormattedNumber("".concat(valueStr, "00")));
      }
    }
  }

  useEffect(() => {
    updateInputValue();
  }, [props.value]);
  return /*#__PURE__*/React.createElement(InputBoxed, _extends({}, props, {
    onChange: e => onChangeInput(e),
    value: inputValue,
    ref: ref
  }));
});
export { InputCurrency };
//# sourceMappingURL=InputCurrency.js.map